import { useState } from 'react'
import { Modal } from 'almanac-ui/Modal'

import Styles from './ConfirmPriceIncreaseModal.module.scss'

import { ConfirmPriceIncreaseModalProps } from './Types'
import { Button } from 'components/Button'
import { Spinner } from 'common/Spinner/Spinner'
import { PriceIncreaseMessage } from 'components/Growth/InviteTeamModal/components/PriceIncreaseMessage/PriceIncreaseMessage'

const ConfirmPriceIncreaseModal = ({
  close,
  onConfirm,
  currentPlan,
  newMemberCount,
  isBillingMonthly,
}: ConfirmPriceIncreaseModalProps) => {
  const [isProcessing, setIsProcessing] = useState(false)

  const handleConfirm = async () => {
    setIsProcessing(true)
    await onConfirm()
    setIsProcessing(false)
    close()
  }

  return (
    <Modal.Root>
      <Modal.Header
        title="Confirm your price increase"
        isConfirmation
        subHeader={
          <PriceIncreaseMessage
            currentPlan={currentPlan}
            isBillingMonthly={isBillingMonthly}
            newMemberCount={newMemberCount}
          />
        }
      />
      <Modal.Footer isConfirmation>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="secondary" onPress={close}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button isDisabled={isProcessing} onPress={handleConfirm} size="lg">
            {isProcessing && <Spinner className={Styles.loadingSpinner} />}
            Confirm
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}

export { ConfirmPriceIncreaseModal }
